module.exports = __webpack_public_path__ + "img/symbol_2.b0e800a5.png";